import { GET_BUSY } from "./const";

export default {

    [GET_BUSY](state) {
        return state.busy;
    }
}